// 用户长时间未操作 退出登录
import store from '../store/index'
import router from '@/router'
import { getSession, delSession } from '@/api/common'
import { MessageBox } from 'element-ui'
import { CHAT } from '@/common/websocket/index'
import i18n from '@/common/i18n'
var timer = null

clearInterval(timer)

export function checkOperation() {
  // 最后一次点击时间
  window.localStorage.setItem('lastTime', new Date().getTime())
  // 当前时间
  let currentTime = new Date().getTime()
  // 允许最长未操作时间
  let timeOut = 120 * 60 * 1000
  // 定时器判断间隔时间
  let timeInterval = 5 * 1000
  function handlechear() {
    clearInterval(timer)
    timer = null
  }
  function handleReset() {
    // 重新赋值最后一次点击时间，清除定时器，重新开始定时器
    window.localStorage.setItem('lastTime', new Date().getTime())
    if (store.state.openVedio) {
      handlechear()
    } else if (
      window.location.href.includes('/realvideo') ||
      window.location.href.includes('/Intercom') ||
      window.location.href.includes('/externalHistory') ||
      window.location.href.includes('/monitor')
    ) {
      handlechear()
    } else {
      if (timer) {
        handlechear()
      }
      if (!timer) {
        handleInterval()
      }
    }
  }

  document.onclick = () => {
    // 单击事件
    handleReset()
  }

  document.ondblclick = () => {
    // 双击事件
    handleReset()
  }

  document.onmousedown = () => {
    // 按下鼠标键时触发
    handleReset()
  }

  document.onmouseup = () => {
    // 释放按下的鼠标键时触发
    handleReset()
  }

  document.onmousemove = () => {
    // 鼠标移动事件
    handleReset()
  }

  document.onmouseover = () => {
    // 移入事件
    handleReset()
  }

  document.onmouseout = () => {
    // 移出事件
    handleReset()
  }

  document.onmouseenter = () => {
    // 移入事件
    handleReset()
  }

  document.onmouseleave = () => {
    // 移出事件
    handleReset()
  }

  document.onkeydown = () => {
    // 键盘按下事件
    handleReset()
  }

  function handleInterval() {
    // 定时器
    timer = setInterval(() => {
      // 当前时间
      currentTime = new Date().getTime()
      let lastTime = window.localStorage.getItem('lastTime')
      // console.log(lastTime,"lastTime")
      if (currentTime - lastTime > timeOut && getSession('access_token')) {
        // 清除定时器
        clearInterval(timer)
        // MessageBox.close(false)
        delSession('access_token')
        delSession('expireTime')
        delSession('HWSecurity_access_token')
        store.commit('voiceShow', false)
        // 关闭对讲
        store.commit('walkieShow', false)
        sessionStorage.removeItem('featureCode')
        sessionStorage.removeItem('isAdmin')
        sessionStorage.removeItem('account')
        // window.localStorage.removeItem('_video')
        window.localStorage.toUrl = window.location.pathname
        let message = document.getElementsByClassName('el-message-box')
        if (message.length > 0) {
          MessageBox.close(false)
        }
        MessageBox.alert(i18n.t('operationLongTime'), '', {
          confirmButtonText: i18n.t('determine'),
          type: 'warning',
          beforeClose: (action, instance, done) => {
            done()
          },
          callback: action => {
            router.push({ path: '/Login' })
          },
        })
        window.CHAT.socket.close()
        CHAT.wsclose()
      }
    }, timeInterval)
  }
  // 一开始程序 默认执行定制器
  handleInterval()
}
